<template>
  <body id="app">

    <HeaderCollapsible
      v-if="!isLoginPage"
      id="header"
      v-bind:links="routes"
      v-bind:account="isAccountVisible"
    >
    </HeaderCollapsible>

    <router-view />

    <FooterFixed
      v-if="!isLoginPage"
      id="footer"
    >
    </FooterFixed>

    <ToastNotification />

    <v-dialog />

  </body>
</template>
<script>
import HeaderCollapsible from '@/components/HeaderCollapsible.vue'
import FooterFixed from '@/components/FooterFixed.vue'
import ToastNotification from '@/components/common/ToastNotification.vue'

import {vuex} from '@/components/mixin/vuex.js'
import {routesForPermissions} from '@/components/mixin/navigationRoutes.js'

export default{
  name: 'home',
  data(){
    return{

    }
  },
  components:{
      HeaderCollapsible,
      FooterFixed,
      ToastNotification
  },
  mixins: [
    vuex
    ],
  computed: {
      isLoginPage: function() {
    return this.$route.path === '/inicio' || this.$route.meta.allowAnonymous === true;
  },
  allowsAnonymous: function() {
    return this.$route.meta.allowAnonymous === true;
  },
    isAccountVisible: function() {
      if(this.$store.getters.getPermissions) {
        return true;
      }
      return false;
    },
    routes: function(){
      return routesForPermissions(this.$store.getters.getPermissions);
    },
  },
  props: [],
  methods:{

  },
  beforeUpdate () {
    if(this.$route.fullPath != '/acerca-de' && !this.allowsAnonymous) {
      this.$store.getters.getPermissions? true:this.$router.push('/inicio')
    }
  },
  updated () {
    
  },
  created () {
    //Si se está accediendo al sitio en una nueva pestaña, intenta recuperar la sesión pública
    //Verifica si existe la cookie session_public y escribe el rol del usuario en Vuex (válido solo para esta pestaña)
    //Lo mismo para token de sesión
    this.$store.commit('setPermissions');
    //this.$store.commit('setToken');

    //Por defecto, se envía el token de sesión en cada consulta
    //this.$http.defaults.headers.common = {'Authorization': 'Bearer ' + this.$store.getters.getToken}
  },
  mounted () {
    if(this.$route.fullPath != '/acerca-de' && !this.allowsAnonymous) {
      this.$store.getters.getPermissions? true:this.$router.push('/inicio')
    }
    if(window.screen.width > 640) {
      this.$store.commit('setIsNotMobile');
    } else {
      this.$store.commit('setIsMobile');
    }
  },
watch: {
    'isMapActive': function(newValue, oldValue) {
      let footer = document.getElementById('footer');

      if (!footer) {
        return;
      }

      if(newValue) {
        footer.style.display = 'none';
        console.log('hide footer');
      } else {
        footer.style.display = 'grid';
        console.log('show footer');
      }
    }
  }
}
</script>

<style scoped>
.migration-banner {
  padding: 0.5em 5%;
  background: #fff3cd;
  color: #664d03;
  border-bottom: 1px solid #ffecb5;
  text-align: center;
}
</style>
